import React, { forwardRef } from 'react';
import { StyledCard, ActionField } from './styled';
/**
 * Card component.
 *
 * @component
 * @param {CardPropsT} props - Properties passed to component.
 * @returns {React.ElementType}
 */
export const Card = forwardRef(function Card({ component = 'div', children, action, elevation, ...props }, ref) {
    return (React.createElement(StyledCard, { ...props, ref: ref, as: component, "$elevation": elevation },
        action && React.createElement(ActionField, null, action),
        children));
});
Card.displayName = 'Card';
